export default "__VITE_ASSET__C6Vwvd2k__"